import React from 'react';
import { useLanguage } from '../app-config-provider';
import LocalIntlProvider from './LocalIntlProvider';

/** 国际化组件 */
const AppIntlProvider: React.FC<{ children: React.ReactNode }> = (props) => {
  const { children } = props;
  const language = useLanguage();

  return <LocalIntlProvider language={language}>{children}</LocalIntlProvider>;
};

export default AppIntlProvider;
